import api from "../../utils/api";
import { getDirectDealStatusLabel } from "@/mixins/buy-direct/const/buyDirectConstant";

export const state = {
  directSurvey: null,
};

export const mutations = {
  setDirectSurvey(state, data) {
    state.directSurvey = data;
  },
};

export const actions = {
  /**
   * 직거래 알림 설정 여부 확인.
   * @returns {boolean} 이미 알림 설정된 사용자인지 여부
   */
  async acCheckDirectAlarm() {
    const url = `/api/v1/buy-direct/alarm/check`;
    try {
      const result = await api.get(url);
      return result?.data?.data?.alreadySet || false;
    } catch (error) {
      return false;
    }
  },

  /**
   * 직거래 알림 설정.
   * @param {string} trafficSource 유입 경로
   * @param {string} directDealStatus 직거래 상태 (Type-Think, Type-Search, Type-Confirm)
   */
  async acSetDirectAlarm(_, params) {
    const url = `/api/v1/buy-direct/alarm`;
    const requestBody = {
      traffic_source: params.trafficSource,
      direct_deal_status: getDirectDealStatusLabel(params.directDealStatus),
    };
    try {
      const result = await api.post(url, requestBody);
      return result?.data?.code === 0;
    } catch (error) {
      return false;
    }
  },

  /**
   * 직거래 의견 등록.
   * @param {string} trafficSource 유입 경로
   * @param {string} directDealStatus 직거래 상태 (Type-Think, Type-Search, Type-Confirm)
   * @param {string} comment 의견 내용
   */
  async acAddDirectComment(_, params) {
    const url = `/api/v1/buy-direct/comment`;
    const requestBody = {
      traffic_source: params.trafficSource,
      direct_deal_status: getDirectDealStatusLabel(params.directDealStatus),
      comment: params.comment,
    };
    try {
      const result = await api.post(url, requestBody);
      if (result?.data?.code === 0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },

  /**
   * 직거래 수요조사 조회 및 store에 저장.
   * @param {string} reportSeq 리포트 시퀀스 (암호화)
   */
  async acGetDirectSurvey({ commit }, reportSeq) {
    const url = `/api/v1/buy-direct-survey/${encodeURIComponent(reportSeq)}/direct-survey`;
    try {
      const result = await api.get(url);
      commit("setDirectSurvey", result?.data?.data || null);
    } catch (error) {
      commit("setDirectSurvey", null);
    }
  },

  /**
   * 직거래 수요조사 업데이트.
   * @param {string} reportSeq 리포트 시퀀스 (암호화)
   * @param {boolean} directYn 직거래 여부
   * @param {string} balanceDate 잔금일 (YYYY-MM-DD 형식, optional)
   * @returns {boolean} 성공 여부
   */
  async acUpdateDirectSurvey(_, { reportSeq, directYn, balanceDate }) {
    const url = `/api/v1/buy-direct-survey/${encodeURIComponent(reportSeq)}/direct-survey`;
    const requestBody = { direct_yn: directYn };
    if (balanceDate) {
      // 날짜 형식 변환: "YYYY-MM-DD" → "YYYYMMDD"
      requestBody.balance_date = balanceDate.replace(/-/g, "");
    }
    try {
      const result = await api.patch(url, requestBody);
      return result?.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
